<script>
import EcSpinner from '../ui/EcSpinner.vue'
import GenericServiceConfig from './services/GenericServiceConfig.vue'
import GHLConfig from './services/GHLConfig.vue'

export default {
  name: 'ModuleCredentialEditor',
  components: { EcSpinner, GenericServiceConfig, GHLConfig },
  props: {
    service: { type: Object, required: true },
    organization: { type: Object, required: true },
  },
  data() {
    return {
      // Built-in service-specific configs
      builtInConfigs: {
        ghl: GHLConfig,
        gohighlevel: GHLConfig,
      },
      // Injectable registry from the host app
      appConfigs: this.$ecServiceConfigs || {},
    }
  },
  computed: {
    resolvedComponent() {
      const slug = this.service.slug?.toLowerCase() ?? ''

      // 1. App-level override (highest priority)
      if (this.appConfigs[slug]) return this.appConfigs[slug]

      // 2. Built-in service config
      if (this.builtInConfigs[slug]) return this.builtInConfigs[slug]

      // 3. Generic fallback
      return GenericServiceConfig
    },
  },
  methods: {
    handleSubmitted(payload) {
      this.$emit('submitted', payload)
    },
    handleCancelled() {
      this.$emit('cancelled')
    },
  },
}
</script>

<template>
  <div class="ec-credential-editor">
    <component
      :is="resolvedComponent"
      :service="service"
      :organization="organization"
      @submitted="handleSubmitted"
      @cancelled="handleCancelled"
    />
  </div>
</template>
